import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { formatINR, finalPrice } from '../utils/priceFormat';

const PH = 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=400&q=70';

// Track recently viewed
function trackViewed(product) {
  try {
    const key = 'vkg_recently_viewed';
    const raw  = localStorage.getItem(key);
    const list = raw ? JSON.parse(raw) : [];
    const filtered = list.filter(p => p.id !== product.id);
    const updated  = [{ id:product.id, slug:product.slug, name:product.name, photo:product.photo||(product.photos?.[0]||''), selling_price:product.selling_price, discount_pct:product.discount_pct }, ...filtered].slice(0, 12);
    localStorage.setItem(key, JSON.stringify(updated));
  } catch {}
}

export default function ProductCard({ product }) {
  const navigate      = useNavigate();
  const { addToCart } = useCart();
  const { user }      = useAuth();

  const price = finalPrice(product.selling_price, product.discount_pct);

  const photo = (() => {
    const raw = product.photo || (Array.isArray(product.photos) && product.photos[0]) || '';
    if (!raw) return PH;
    if (raw.startsWith('http')) return raw;
    return 'https://shop.venkatagirihandlooms.com/' + raw.replace(/^\/+/, '');
  })();

  const handleClick = () => { trackViewed({...product, photo}); navigate(`/product/${product.slug}`); };

  const handleAddToCart = async (e) => {
    e.stopPropagation();
    if (!user) { toast.error('Please login to add to cart'); navigate('/login'); return; }
    try { await addToCart(product.id, 1); toast.success('Added to cart! 🛒'); }
    catch (err) { toast.error(err.message); }
  };

  const handleWishlist = async (e) => {
    e.stopPropagation();
    if (!user) { toast.error('Please login'); navigate('/login'); return; }
    try { await api.post('/wishlist', { product_id: product.id }); toast.success('Saved to wishlist ❤️'); }
    catch (err) { toast.error(err.message); }
  };

  return (
    <div className="product-card" onClick={handleClick}>
      <div className="product-card-image">
        <img src={photo} alt={product.name} onError={e => { e.target.src = PH; }} loading="lazy"/>
        {product.is_new && !product.discount_pct  && <span className="product-card-badge badge-new">New</span>}
        {product.discount_pct > 0                 && <span className="product-card-badge badge-sale">-{product.discount_pct}%</span>}
        {product.featured && !product.is_new && !product.discount_pct && <span className="product-card-badge badge-featured">Featured</span>}
        <div className="product-card-actions">
          <button className="icon-btn" onClick={handleWishlist} title="Wishlist">❤️</button>
          <button className="icon-btn" onClick={handleAddToCart} title="Add to Cart">🛒</button>
          <button className="icon-btn" onClick={e=>{ e.stopPropagation(); handleClick(); }} title="View">👁️</button>
        </div>
      </div>
      <div className="product-card-body">
        {product.category_name && <div className="product-card-cat">{product.category_name}</div>}
        <div className="product-card-name">{product.name}</div>
        {product.material && <div style={{fontSize:11,color:'#8a7968',marginBottom:6}}>{product.material}</div>}

        {/* ── Professional price display ── */}
        <div className="product-card-price">
          <span className="price-display price-md">
            <span className="price-inr">₹</span>
            {formatINR(price)}
          </span>
          {product.discount_pct > 0 && <>
            <span className="price-strike">₹{formatINR(product.selling_price)}</span>
            <span className="price-save">{product.discount_pct}% OFF</span>
          </>}
        </div>

        {/* Stars if rating exists */}
        {product.avg_rating > 0 && (
          <div style={{marginTop:5,display:'flex',alignItems:'center',gap:5}}>
            <span className="stars stars-sm">{'★'.repeat(Math.round(product.avg_rating))}</span>
            <span style={{fontSize:10,color:'#8a7968'}}>({product.review_count||0})</span>
          </div>
        )}

        {product.stock_qty <= 5 && product.stock_qty > 0 && <div style={{fontSize:10,color:'#e65100',marginTop:5,fontWeight:600}}>Only {product.stock_qty} left!</div>}
        {product.stock_qty === 0 && <div style={{fontSize:10,color:'#999',marginTop:5}}>Out of Stock</div>}
      </div>
    </div>
  );
}
